/* tslint:disable */
/* eslint-disable */
/**
 * radia.cz
 * Seznam endpointu
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FrontApplicationInputResetCodeInputModel
 */
export interface FrontApplicationInputResetCodeInputModel {
    /**
     * Kód
     * @type {string}
     * @memberof FrontApplicationInputResetCodeInputModel
     */
    code: string;
    /**
     * Mail
     * @type {string}
     * @memberof FrontApplicationInputResetCodeInputModel
     */
    email: string;
    /**
     * Nové heslo
     * @type {string}
     * @memberof FrontApplicationInputResetCodeInputModel
     */
    password: string;
}

/**
 * Check if a given object implements the FrontApplicationInputResetCodeInputModel interface.
 */
export function instanceOfFrontApplicationInputResetCodeInputModel(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "code" in value;
    isInstance = isInstance && "email" in value;
    isInstance = isInstance && "password" in value;

    return isInstance;
}

export function FrontApplicationInputResetCodeInputModelFromJSON(json: any): FrontApplicationInputResetCodeInputModel {
    return FrontApplicationInputResetCodeInputModelFromJSONTyped(json, false);
}

export function FrontApplicationInputResetCodeInputModelFromJSONTyped(json: any, ignoreDiscriminator: boolean): FrontApplicationInputResetCodeInputModel {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'code': json['code'],
        'email': json['email'],
        'password': json['password'],
    };
}

export function FrontApplicationInputResetCodeInputModelToJSON(value?: FrontApplicationInputResetCodeInputModel | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'code': value.code,
        'email': value.email,
        'password': value.password,
    };
}

